"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioButton = void 0;
var React = require("react");
var ErrorMessage_1 = require("../ErrorMessage");
var RadioButton = function (props) {
    var attributes = {
        className: 'form-check-input',
        id: props.id,
        type: 'radio',
    };
    // When "name" is not provided, it defaults to the value of "id"
    attributes.name = typeof props.name !== 'undefined' ? props.name : props.id;
    // When "value" is not provided, it defaults to the value of "id"
    attributes.value = typeof props.value !== 'undefined' ? props.value : props.id;
    // Handle error state
    var ErrorMessageComponent;
    if (props.isValid === false) {
        // Invalid
        attributes.className += ' is-invalid';
        attributes['aria-invalid'] = true;
        // Invalid with error message
        if (props.errormessage) {
            attributes['aria-describedby'] = props.id + "-errormessage";
            ErrorMessageComponent = (React.createElement(ErrorMessage_1.ErrorMessage, { id: props.id, message: props.errormessage }));
        }
        // Invalid in checkbox list
        else if (props.ariaDescribedBy) {
            attributes['aria-describedby'] = props.ariaDescribedBy;
        }
    }
    // Allow checkboxes to be arranged horizontally
    var wrapperClassName = 'form-check';
    if (props.inline) {
        wrapperClassName += ' form-check-inline';
    }
    // Add the onChange handler
    if (typeof props.onChange === 'function') {
        attributes.onChange = function (e) {
            var name = e.target.name;
            var value = e.target.value;
            // @ts-ignore
            props.onChange(name, value, e);
        };
        attributes.checked = props.checked;
    }
    else {
        attributes.defaultChecked = props.checked;
    }
    return (React.createElement("div", { className: wrapperClassName },
        React.createElement("input", __assign({}, attributes)),
        React.createElement("label", { className: "form-check-label", htmlFor: props.id },
            React.createElement("span", { className: "form-check-label-text" },
                props.label,
                props.labelSecondary && React.createElement("span", { className: "form-check-label-text-secondary" }, props.labelSecondary))),
        ErrorMessageComponent));
};
exports.RadioButton = RadioButton;
exports.RadioButton.defaultProps = {
    checked: false,
};
